import { cn } from '../utils/cn'

export default function CardCinza({ children, className = '' }) {
  return (
    <div
      className={cn(
        'bg-gradient-to-b from-[#2D2B37] to-[#1C1A24] rounded-2xl shadow-lg p-8 w-[254px]',
        className,
      )}
    >
      {children}
    </div>
  )
}
